export default "skymp5-front/3c3739daa06c3b98bb5dfc9fdf5327d9.png";